import { render, staticRenderFns } from "./DeleteStaffModal.vue?vue&type=template&id=4b41c902&"
import script from "./DeleteStaffModal.vue?vue&type=script&lang=js&"
export * from "./DeleteStaffModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteStaffModal.vue?vue&type=style&index=0&id=4b41c902&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports